export const STORE_KEY = {
  auth: "calorie-grid-auth",
  authSession: "calorie-grid-auth-session",
} as const;

export const STORE_VERSION = 1;
